var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgBinoculars = function SvgBinoculars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16a3 3 0 11-6 0 3 3 0 016 0zm0 0v-6c0-.552-.672-1-1.5-1-.829 0-1.232.37-1.42.68l-2.84 5.133M14 16a3 3 0 106 0 3 3 0 00-6 0zm0 0v-6c0-.552.672-1 1.5-1 .829 0 1.232.37 1.421.68l2.84 5.133M16.346 9.17l-.729-1.261c-.16-.248-1.056-.203-1.117.091l-.177 1.38m-6.669-.21l.73-1.261c.16-.25 1.055-.203 1.116.09l.177 1.38M10 12h4v2h-4v-2z",
    stroke: "#5E6B78",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBinoculars;